import "./profile.css";
import React from "react";
import { useNavigate } from "react-router-dom";
import { PiUserCircle, PiBell } from "react-icons/pi";
import { IoIosArrowForward } from "react-icons/io";
import { TbLogout2 } from "react-icons/tb";
import Avatar from "../../../assets/Avatar.png";
import TokenService from "../../../services/token.service";

function Profile({ user }) {
	const navigate = useNavigate();

	// Handle Logout
	const handleLogout = () => {
		TokenService.clearStorage();
		navigate("/");
	};

	return (
		<main className="profile_screen">
			<div className="profile_pic">
				<img src={Avatar} alt="profile pic" />
				<p>{user}</p>
			</div>
			<div className="profile_item_div">
				<PiUserCircle className="profile_icon" />
				<div className="profile_item_inner_div">
					<p>View Profile</p>
					<IoIosArrowForward className="view_profile_item_icon" />
				</div>
			</div>
			<div className="profile_item_div">
				<PiBell className="profile_icon" />
				<div
					className="profile_item_inner_div"
					onClick={() => navigate("/dashboard/notification")}
				>
					<p>See Notifications</p>
					<IoIosArrowForward className="view_profile_item_icon" />
				</div>
			</div>
			<div className="profile_item_div">
				<TbLogout2 className="profile_icon" />
				<div className="profile_item_inner_div">
					<p style={{ color: "red" }} onClick={handleLogout}>
						Logout
					</p>
				</div>
			</div>
		</main>
	);
}

export default Profile;
